/**
 * device-storage's Latest Build (its CONTEXT.md): the build in production while
 * there is one, else the current build. Lists show, filter and sort by it, the
 * shipping date included, so a device in production has none yet. Never mix
 * fields of the two builds.
 */
export function latestBuild<T>(
  device?: {
    buildInProduction?: T;
    currentBuild?: T;
  } | null,
): T | undefined {
  return device?.buildInProduction ?? device?.currentBuild;
}
